import React from 'react';
import PropTypes from 'prop-types';
import {GridLoader} from 'react-spinners';

class progress extends React.Component {
	render () {
		return (
			<div id="progress_wrapper">
				<GridLoader
					size={15}
					margin={"10px"}
					color={'rgb(64,186,208)'}
				/>
				{this.props.subContents}
			</div>
		);
	}
}
progress.propTypes = {
	subContents:PropTypes.object
};
export default progress;



// WEBPACK FOOTER //
// ./src/common/containers/progress.js